<div class="d-block d-lg-none">
  <fgb-mobile-page-header
    pageTitle="wallet.page.banner"
    [showBalance]="false"
    [showQr]="false"
    [showFooter]="true"
    [backButtonLink]="'/rewards/wallet'"
  ></fgb-mobile-page-header>
</div>

<div class="container">
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="page-padding">
      <a class="cursor-pointer wallet-back-button mb-3 bg-glass-dark" (click)="goBack()">
        <span class="icon material-icons text-white">arrow_back_ios</span>
      </a>
    </div>
  </ng-container>
  <fgbcl-auction-wallet-details [id]="id"></fgbcl-auction-wallet-details>
</div>
